// When we are rendering without the portal in Desktop,
// we just render the children directly as if this function
import React from "react";

import platformIdentifiers from "../../constants/platformIdentifiers";
import PortalChild from "./PortalChild";

const withoutPortal = children => children;

export const asPortalChild = (children, key = null) => <PortalChild key={key}>{children}</PortalChild>;

export const asOptionalPortalChild = (children, target = platformIdentifiers.MOBILE) => {
  let usePortal = false;
  //#!if iOS === true
// if (target === platformIdentifiers.IOS) {
// usePortal = true;
// }
  //#!endif
  //#!if mobile === true
// if (target === platformIdentifiers.MOBILE) {
// usePortal = true;
// }
  //#!endif
  //#!if tablet === true
// if (target === platformIdentifiers.TABLET) {
// usePortal = true;
// }
  //#!endif
  //#!if desktop === true
  if (target === platformIdentifiers.DESKTOP) {
    usePortal = true;
  }
  //#!endif
  if (target === platformIdentifiers.ALL) {
    usePortal = true;
  }

  return usePortal ? asPortalChild(children) : withoutPortal(children);
};
